import { React, models, kea, history, resources, selectores, componentToRx, Route } from "app/main/std";
import { fa } from "typed-font-awesome";

type Entity = models.UsuarioDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre }) },
    { title: "login", cell: x => ({ data: x.Login }) },
    { title: "Rol", cell: x => ({ data: x.NombreRol }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "En turno", cell: x => ({ data: x.EnTurno }) },
    { title: "Habilitado", cell: x => ({ data: x.Habilitado }) },
    { title: "Caja documentación", cell: x => ({ data: x.CajaDocumentacion.NombreCaja }) },
    { title: "Caja entrega dom.", cell: x => ({ data: x.CajaEntregaDomicilio.NombreCaja }) },
    { title: "Caja entrega ocu.", cell: x => ({ data: x.CajaEntregaOcurre.NombreCaja }) },
    { title: "Caja cobranza", cell: x => ({ data: x.CajaCobranza.NombreCaja }) },
];

export interface BotonesDeps {
    onRemplazar: (item: Entity) => void;
    onBorrar: (item: Entity) => void;
    onEdit: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Editar",
            style: "primary",
            iconClass: fa("pencil"),
            onClick: deps.onEdit
        },
        {
            tooltip: "Eliminar",
            style: "danger",
            iconClass: fa("trash"),
            onClick: deps.onBorrar
        },
        {
            tooltip: "Remplazar",
            style: "success",
            iconClass: fa("reply-all"),
            onClick: deps.onRemplazar
        }
    ]);

    return columna;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarios/list/columns.tsx